import { Tooltip } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

export const TransferSyncFailedIcon: FC = () => (
  <Tooltip title='AS400 sync failed'>
    <WarningOutlined className='text-secondary-600' fontSize='small' />
  </Tooltip>
)
